module.exports = __webpack_public_path__ + "img/kw.33b3292e.svg";